import { IValidations } from "../shared/models/validations";
import { MESSAGES, TOAST_HEADER } from "./constants";
import { store } from 'react-notifications-component';
import { NotificationType } from "../shared/models/mainDashboardModel";
import moment from "moment";

export const updateObject = (oldObject: any, updatedProperties: any) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkIsValidEmail = (email: string) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(String(email.toLowerCase()));
}

export const checkIsValidPhoneNumber = (phone: string) => {
    const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    return phoneRegex.test(String(phone.toLowerCase()));
}

export const setItemToStorage = (key: string, value: any) => localStorage.setItem(key, JSON.stringify(value));

export const getItemFromStorage = (key: string) => {
    const data = localStorage.getItem(key) as string;
    return JSON.parse(data);
}

export const clearStorage = () => localStorage.clear();


export const removeItemFromStorage = (key: string) => localStorage.removeItem(key);

export const checkPasswordValidation = (password: string) => {
    // • Min 8 chars
    // • Upper and Lower case required
    // • 1 or more digits
    // • 1 special character
    const pwd = password.trim();
    if (pwd.length < 8) {
        return false;
    } else {
        // Checking atleast one character and numeric
        // const pattern = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
        const pattern = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,}$/
        return pattern.test(pwd);
    }
}

export const checkIsNumericOrEmpty = (value: any) => {
    const regex = /^(|\d)+$/;

    return regex.test(value);
}

export const checkProperties = (obj:any) =>  {
    const isEmpty = Object.values(obj).every(x => (x === null || x === ''));
    return isEmpty;
}

export const checkFieldValidation = (validation: IValidations, value: any,secondValue?: any) => {
    let error: string | false = '';
    if (validation) {
        if (validation.required) {
            error = (!value || (value && !value.trim())) && MESSAGES.requiredField(validation.label || '');
        }
        if (!error && validation.email) {
            error = (!value || (value && !checkIsValidEmail(value.trim()))) && MESSAGES.emailIsInvalid;
        }
        if (!error && validation.password) {
            error = (!value || (value && !checkPasswordValidation(value))) && MESSAGES.passwordStrength;
        }
        if (!error && validation.passwordMatch) {
            error = (!value || (value !== secondValue)) && MESSAGES.passwordNotMatch;
        }
        if (!error && validation.phone) {
            error =  (value && !checkIsValidPhoneNumber(value.trim())) && MESSAGES.invalidPhoneNumber;
        }
        return error || null ;
    }
}

export const escapeRegexCharacters = (str: string) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const getAddress = (customer: any) => {
    let address = '';
    const { address1, address2, town, city, postcode } = customer || {}
    if (address1) {
        address = address1;
    }
    if (address2) {
        address = address ?  address + ', ' + address2 : address2;
    }
    if (town) {
        address = address ? address + ', ' + town : town;
    }
    if (city) {
        address = address ? address + ', ' + city : city;
    }
    if (postcode) {
        address = address ? address + ', ' + postcode : postcode;
    }
    
    return address || 'Not available';
}

export const showNotification = (type: string ,message: string, title?: string,) => {
    store.addNotification({
        title: title,
        message: message,
        type: type,
        insert: "top",
        container: "top-left",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 2000,
          onScreen: false,
          showIcon:true,
        }
      });
}

export const showSuccess = (message: string) => {
    showNotification(NotificationType.success,message);
}

export const showError = (message: string) => {
    showNotification(NotificationType.error,message);
}

export const getYearList = () => {
    const minYear = 1990;
    const maxYear = new Date().getFullYear() + 10;
    const yearList: number[] = []

    for (let i = minYear; i <= maxYear; i++) {
        yearList.push(i);
    }

    return yearList;
}

export const convertUTCDateToLocalDate = (date: string, format = 'DD MMM YYYY hh:mm a') => {
    return moment(date).format(format);
}